module.exports=[
  {
    "question": "How do I know if catering is offered for my space booking?",
    "answer": "Catering will be available if your event is in the LA Metro area with 6 or more attendees and you've booked at least 48 hours ahead."
  },
  {
    "question": "What if I don't know the final details yet, like guest count or location?",
    "answer": "Not sure on your final guest count? Reserve your package now so you lock in your date, and you can update guest count closer to the event. If you're not ready to book yet, don’t worry, you can book up to 48 hours in advance of your event. You can make menu adjustments up to 3 days in advance. If booking within 7 days of your event for a large group, your chef may need to alter the menu - we'll be in touch if that's the case!"
  },
  {
    "question": "What if I have special requests or dietary restrictions?",
    "answer": "You can add that when booking, and re-confirm with the caterer directly once booked."
  },
  {
    "question": "Do you offer bartending packages?",
    "answer": "Yes! After you select your menu, you will be able to add on beverages including bar options. The package includes a bartender and your choice of alcoholic beverages. Keep in mind, if you haven't done so already your host should be informed that you plan to serve alcohol."
  },
  {
    "question": "What do I need to bring with me?",
    "answer": "Unless otherwise specified, please provide all tableware required (plates, utensils, etc.). You can request tableware to be included for an additional fee post booking. We recommend checking with your host to see what is provided on site."
  },
  {
    "question": "Who is providing catering?",
    "answer": "Peerspace is supported by local caterers, available exclusively through our partner Cozymeal. Once you select your package you will book through Cozymeal and they will handle all the details."
  },
  {
    "question": "What if I run into an issue?",
    "answer": "Our goal is always to deliver excellent quality and ensure you feel great about your choice. We're confident you'll be satisfied with your purchase. If your order doesn't meet our high standards, we'll make it right. Simply take photos to document any issues, and reach out to us within 48 hours after your event."
  },
  {
    "question": "What is the cancellation policy?",
    "answer": "For groups of less than 10, you may cancel by 48 hours before your event. For groups of 10 or more, you may cancel by 7 days before your event for a full refund. If your catering event is booked within 7 days of the event date, the order is non-refundable unless the chef cannot fulfill it. "
  }
]
